type InitActorInputs = {
    defaultRegionCode: string;
    includeRegionInUrl?: boolean;
    url: string;
};

export function resolveRegionalizedUrl(regionCode: string, input: InitActorInputs) {
    const isDefaultRegion = regionCode.toLowerCase() === input.defaultRegionCode.toLowerCase();

    if (!isDefaultRegion && input.includeRegionInUrl) {
        return `/${regionCode.toLowerCase()}${input.url}`;
    }

    return input.url;
}
